"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entryVarStringInterpolationGetInterpolationNames = (stringToInterpolate) => {
    var _a;
    const regexOfInterpolation = /\$\{[^]+?\}/g;
    const rawInterpolationNames = (_a = stringToInterpolate.match(regexOfInterpolation)) !== null && _a !== void 0 ? _a : [];
    const allNames = rawInterpolationNames
        .map((rawInterpolationName) => rawInterpolationName.replace(/^\$\{/, '').replace(/\}$/, ''))
        .map((name) => ({
        name,
        isValid: /^[A-Za-z_]+$/.test(name),
    }));
    return allNames.filter((name, nameIndex) => {
        const prevIndex = allNames.findIndex((prevName) => prevName.name === name.name);
        return prevIndex === nameIndex;
    });
};
exports.default = entryVarStringInterpolationGetInterpolationNames;
